// extracted by mini-css-extract-plugin
export default {"projectResults":"projectResults__Au0LUp","searchRow":"searchRow__mvCP8v"};